import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { EmptyMessageComponent } from '../empty-message/empty-message.component';

@Component({
  selector: 'vnm-table-empty-message',
  templateUrl: './table-empty-message.component.html',
  styleUrls: ['./table-empty-message.component.scss']
})
export class TableEmptyMessageComponent extends EmptyMessageComponent implements OnInit {
  readonly colSpan = Number.MAX_SAFE_INTEGER;
  @ViewChild('messageTemplate', { static: true }) messageTemplate;

  constructor(private viewContainerRef: ViewContainerRef) {
    super();
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.messageTemplate);
  }
}
